import debug from 'debug';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';

const logger = debug('web:application:utils:firebase');

const getFirebaseOptions = () => {
  const apiKey = process.env.FIREBASE_API_KEY;
  const authDomain = process.env.FIREBASE_AUTH_DOMAIN;
  const databaseURL = process.env.FIREBASE_DATABASE_URL;
  const projectId = process.env.FIREBASE_PROJECT_ID;
  const storageBucket = process.env.FIREBASE_STORAGE_BUCKET;
  const messagingSenderId = process.env.FIREBASE_MESSAGING_SENDER_ID;

  if (
    apiKey === undefined ||
    authDomain === undefined ||
    databaseURL === undefined ||
    projectId === undefined ||
    storageBucket === undefined ||
    messagingSenderId === undefined
  ) {
    throw new Error('Firebase configuration not complete, not initializing chat');
  }

  return {
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    storageBucket,
    messagingSenderId,
  };
};

logger('Configuring');
firebase.initializeApp(getFirebaseOptions());
// firebase.database().goOffline();

const disconnectInterval = 6 * 60 * 60 * 1000; // 6 hours
let disconnectTimeout;
export const disconnectDb = () => {
  if (disconnectTimeout) {
    clearTimeout(disconnectTimeout);
  }

  logger('Queueing disconnect');
  disconnectTimeout = setTimeout(() => {
    logger('Disconnecting');
    firebase.database().goOffline();
  }, disconnectInterval);
};

export const configureLiveOverride = async (visibilityOverrideDispatcher) => {
  const db = firebase.database();
  db.goOnline();

  const ref = db.ref('/live-override');
  const fn = (snapshot) => {
    const override = snapshot.val();

    if (override) {
      if (typeof override.enabled === 'boolean') {
        visibilityOverrideDispatcher(override.enabled);
      } else if (typeof override.dev === 'boolean') {
        visibilityOverrideDispatcher(override.dev);
      }
    }
  };

  ref.on('value', fn);
};

export { firebase };
